import { APIResponse } from "@/types/api";
import http from "@/composables/api";
import { VendorDataPayload, VendorDataResponse } from "@/types/interface/vendor";

async function createVendor(payload: VendorDataPayload) {
  return await http.post<APIResponse<VendorDataResponse>>("vendor/create", payload);
}

async function updateVendor(idUnit = '', payload: VendorDataPayload) {
  return await http.patch<APIResponse<VendorDataResponse>>(`vendor/update?id=${idUnit}`, payload);
}

async function getVendor(page = 1, limit = 10, queryParam = "") {
  let pagination = true;
  if (page == 0){
    pagination = false;
  }
  return await http.get<APIResponse<VendorDataResponse>>(`vendor?is_pagination=${pagination}&page=${page}&limit=${limit}${queryParam}`);
}

async function findVendor(idUnit = "") {
  return await http.get<APIResponse<VendorDataResponse>>(`vendor/detail?id=${idUnit}`);
}

async function deleteVendor(idUnit = "") {
  return await http.delete<APIResponse<VendorDataResponse>>(`vendor/delete?id=${idUnit}`);
}

export default {
  createVendor,
  updateVendor,
  getVendor,
  findVendor,
  deleteVendor
};